import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class AbsenceExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getHeaders(): string[] {
    return ['Claim Number', 'Date Begin', 'Date End', 'Status', 'Type'];
  }

  private static mapRowsToExportData(rows: any[]): any[][] {
    return rows.map((row) => [
      row.absenceNumber || '',
      this.formatDate(row.dateBegin),
      this.formatDate(row.dateEnd),
      this.formatStatus(row.activeStatus, row.absenceStatus),
      row.absenceType || '',
    ]);
  }

  private static formatDate(date: any): string {
    if (!date) return '';

    if (date instanceof Date) {
      return date.toLocaleDateString();
    }

    if (typeof date === 'string') {
      const parsedDate = new Date(date);
      return isNaN(parsedDate.getTime())
        ? date
        : parsedDate.toLocaleDateString();
    }

    return String(date);
  }

  private static formatStatus(
    activeStatus: string,
    absenceStatus: string,
  ): string {
    if (!activeStatus && !absenceStatus) return '';
    if (!activeStatus) return absenceStatus || '';
    if (!absenceStatus) return activeStatus || '';
    return `${activeStatus} - ${absenceStatus}`;
  }
}
